import { reAuthenticate } from "@actions/auth";
import axios from "axios";
import { push } from "connected-react-router";
import enums from "./../enums";
import { removeUser } from "./index";
/**
 * Sets auth token to axios header as a Auhorization param
 * @param {String} token Authorization token
 */
export default function setAuthToken(token) {
	if (token) {
		axios.defaults.headers.common["Authorization"] = `Bearer=${token}`;
	}
}

export function startTokenInterceptor(store) {
	axios.interceptors.response.use(undefined, function (err) {
		let url = err.config.url;
		if (
			err?.response?.status === 401 &&
			url.indexOf("/api") > -1 &&
			!store.getState().common.unauthError
		) {
			store.dispatch({ type: enums.UNAUTH_ERROR, payload: true });
			store.dispatch(reAuthenticate());
			// it's legacy and we don't need to remove user because we will reauthenticate user if session is expired
			// removeUser();
			// store.dispatch({ type: enums.LOGOUT_SUCCESS });
			// if (url.indexOf("/profile") < 0) {
			// 	store.dispatch({
			// 		type: enums.ALERT_IN,
			// 		payload: {
			// 			type: "error",
			// 			msg: "SESSION_END",
			// 			title: "SESSION",
			// 		},
			// 	});

			// 	setTimeout(() => {
			// 		store.dispatch({ type: enums.UNAUTH_ERROR, payload: false });
			// 	}, 400);
		}
		throw err;
	});

	//listen child iframe
	window.addEventListener("message", (e) => {
		if (e.origin.indexOf(".wisegaming.com") > -1 && e.data.cmd === "logout") {
			removeUser();
			store.dispatch(push("/"));
			store.dispatch({ type: enums.LOGOUT_SUCCESS });
			alert("Session has expired!");
		}
	});
}
